import React from 'react';

import { IAffiliateHero20Fields } from '../../../../types/contentful';

import MobileView from './Viewports/MobileView';
import DesktopView from './Viewports/DesktopView';

export interface AffiliateHero2Props extends IAffiliateHero20Fields {
  heightForStorybook?: number | string;
  widthForStorybook?: number | string;
}

export function AffiliateHero2(props: AffiliateHero2Props) {
  return (
    <>
      <MobileView {...props} />
      <DesktopView {...props} />
    </>
  );
}
